// ANCHOR React
import { ReactNode } from 'react';

// ANCHOR Toast
import { toast } from 'react-hot-toast';

// ANCHOR Models
import { useUpdateFormQuestionPositionFormSubmit } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionForm';
import { useFormQuestionsMutate } from '@lyon/scoped-models/form/FormQuestionsData';
import { useUpdateFormQuestionPositionModalVisibilityHide } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionModalVisibility';

// ANCHOR API
import { updateFormQuestionPositionById } from '@lyon/utils/api/forms';

// ANCHOR Graph State
import { useAuthToken } from '@lyon/nodes/firebase/auth/auth-token-node';

// ANCHOR Hooks
import { usePromise } from '@lyon/utils/hooks/usePromise';
import { useSentryExceptionHandler } from '@lyon/utils/hooks/useSentryExceptionHandler';

interface IProps {
  children: ReactNode;
}

export function LyonUpdateFormPositionFormContainer({ children }: IProps) {
  const token = useAuthToken();
  const catchException = useSentryExceptionHandler();
  const hide = useUpdateFormQuestionPositionModalVisibilityHide();
  const mutate = useFormQuestionsMutate();

  const [
    position, questionId, setLoading,
  ] = useUpdateFormQuestionPositionFormSubmit();

  const mounted = usePromise([token, questionId, position]);

  async function submit(
    currentToken: string,
    currentPosition: number,
    currentQuestionId: string,
  ) {
    await mounted(updateFormQuestionPositionById({
      token: currentToken,
      id: currentQuestionId,
      position: currentPosition,
    }));

    await mounted(mutate());
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();

        if (token && position && questionId) {
          setLoading(true);
          toast.promise(submit(token, position, questionId), {
            loading: 'Updating form number',
            success: 'Successfully updated form number',
            error: 'Failed updating form number',
          }).then(() => {
            hide();
            setLoading(false);
          }, (error) => {
            catchException(error);
            setLoading(false);
          });
        }
      }}
    >
      {children}
    </form>
  );
}
